(() => {
  'use strict';
  const root = document.getElementById('WholesalePortal');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = (selector) => root.querySelector(selector);

  const transferKey = 'inunokurashi-wholesale-estimate-v1';
  const readTransfer = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(transferKey) || 'null');
      if (!value || !Number.isFinite(value.updatedAt) || Date.now() - value.updatedAt > 86400000 || value.updatedAt > Date.now() + 60000 || typeof value.text !== 'string' || value.text.length > 200000 || !Array.isArray(value.items) || value.items.length > 781) return null;
      if (!value.items.every(item => item && /^\d+$/.test(String(item.variantId)) && Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 9999)) return null;
      return value;
    } catch (_) { return null; }
  };
  const clearTransfer = () => { try { sessionStorage.removeItem(transferKey); } catch (_) { /* Browsing remains available without storage. */ } };
  if (root.dataset.approved !== 'true') clearTransfer();
  if (root.dataset.mode === 'application') {
    const redirectLegacyCatalog = () => {
      if (['#wh-catalog','#wh-estimate'].includes(window.location.hash) && !window.location.search) {
        window.location.replace(root.dataset.catalogUrl + window.location.hash);
      }
    };
    redirectLegacyCatalog();
    window.addEventListener('hashchange', redirectLegacyCatalog);
    if ($('.wh-success')) clearTransfer();
    const attachment = $('#wh-estimate-attachment');
    if (attachment) {
      const transfer = readTransfer();
      if (attachment.value.trim() || transfer) {
        if (!attachment.value.trim()) attachment.value = transfer.text;
        attachment.disabled = false;
        $('#wh-attached-estimate').hidden = false;
        $('#wh-application-message').textContent = 'カタログの見積を添付しています。店舗情報と申請内容をご確認ください。まだ送信はされていません。';
      }
      $('#wh-detach-estimate').addEventListener('click', () => {
        clearTransfer();
        attachment.value = '';
        attachment.disabled = true;
        $('#wh-attached-estimate').hidden = true;
        $('#wh-application-message').textContent = '見積の添付を解除しました。ご相談内容はそのまま残っています。';
      });
    }
  }
  if ($('#wh-email')) {
    const email = $('#wh-email');
    const confirmation = $('#wh-email-confirm');
    const validateEmail = () => confirmation.setCustomValidity(
      confirmation.value && email.value.trim().toLowerCase() !== confirmation.value.trim().toLowerCase()
        ? 'メールアドレスが一致していません。もう一度ご確認ください。' : ''
    );
    email.addEventListener('input', validateEmail);
    confirmation.addEventListener('input', validateEmail);
  }

  const verificationMethod = $('#wh-verification-method');
  if (verificationMethod) {
    const operatingStatus = $('#wh-operating-status');
    const website = $('#wh-website');
    const notes = $('#wh-proof-notes');
    const syncVerificationFields = () => {
      const usesUrl = verificationMethod.value === '公開URLで確認';
      const needsNotes = verificationMethod.value === 'URLなし・追加資料で確認'
        || ['開業準備中', 'その他'].includes(operatingStatus.value);
      $('#wh-public-proof').hidden = !usesUrl;
      website.disabled = !usesUrl;
      website.required = usesUrl;
      notes.required = needsNotes;
      $('#wh-proof-required').hidden = !needsNotes;
      notes.setCustomValidity(needsNotes && !notes.value.trim()
        ? '確認できる資料・方法や、店舗の現在の状況をご記入ください。' : '');
    };
    verificationMethod.addEventListener('change', syncVerificationFields);
    operatingStatus.addEventListener('change', syncVerificationFields);
    notes.addEventListener('input', syncVerificationFields);
    syncVerificationFields();
  }

  if (!$('#wh-products')) return;
  const cards = [...root.querySelectorAll('.wh-product')];
  // Ensure large variant lists remain selectable even if the Liquid loop is limited.
  cards.forEach(card => {
    try {
      const variants = JSON.parse(card.dataset.variants || '[]');
      const select = card.querySelector('.wh-variant');
      card.dataset.search += ' ' + variants.map(v => v.sku || '').join(' ');
      if (variants.length > select.options.length) {
        const current = select.value;
        select.replaceChildren(...variants.map(v => {
          const option = document.createElement('option');
          option.value = String(v.id);
          option.dataset.price = String(v.price);
          option.dataset.available = String(v.available);
          option.dataset.variantTitle = v.title;
          option.dataset.sku = v.sku || '';
          option.disabled = !v.available;
          option.selected = String(v.id) === current;
          option.textContent = `${v.title === 'Default Title' ? '通常' : v.title} ／ ¥${(Number(v.price) / 100).toLocaleString('ja-JP')}${v.available ? '' : '（在庫切れ）'}`;
          return option;
        }));
      }
    } catch (_) { /* Retain server-rendered options if variant data is unavailable. */ }
  });
  const selected = new Map();
  const money = (yen) => new Intl.NumberFormat('ja-JP', {style:'currency',currency:'JPY',maximumFractionDigits:0}).format(yen);
  const rate = (quantity) => quantity >= 100 ? 50 : quantity >= 50 ? 45 : quantity >= 5 ? 40 : 25;
  const lineTotal = (price, quantity, discount) => Math.round(price * quantity * (100 - discount) / 10000);
  const number = (value) => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 9999 ? Number(value) : null;
  let visibleLimit = 24;
  let copyText = '';
  const normalize = (value) => String(value).normalize('NFKC').toLocaleLowerCase('ja').trim();
  const feedback = (message) => { $('#wh-feedback').textContent = message; };
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const categories = [
    {id:'food',label:'おやつ・フード',handles:['おやつ','ふりかけ','鹿骨','鹿角-ジャーキー','オーガニックフード']},
    {id:'mat',label:'ペットマット',handles:['ペットマット']},
    {id:'toy',label:'おもちゃ',handles:['おもちゃ']},
    {id:'dining',label:'お食事グッズ',handles:['お食事グッズ']},
    {id:'walk',label:'首輪・ハーネス・リード',handles:['首輪-ハーネス-リード']},
    {id:'carrier',label:'スリング・キャリー',handles:['スリング-キャリー']},
    {id:'toilet',label:'トイレグッズ',handles:['トイレグッズ']},
    {id:'care',label:'エリザベスカラー',handles:['エリザベスカラー']},
    {id:'gift',label:'ギフト',handles:['ギフトボックス']},
    {id:'other',label:'その他グッズ',handles:['グッズ_その他']}
  ];
  let activeCategory = 'all';
  const cardCategories = new Map(cards.map(card => {
    let handles = [];
    try { handles = JSON.parse(card.dataset.collections || '[]') || []; } catch (_) { /* Unassigned products remain discoverable. */ }
    const ids = categories.filter(category => category.handles.some(handle => handles.includes(handle))).map(category => category.id);
    return [card, ids.length ? ids : ['other']];
  }));
  const categoryButtons = new Map();
  [{id:'all',label:'すべて'},...categories].forEach(category => {
    const count = cards.filter(card => category.id === 'all' || cardCategories.get(card).includes(category.id)).length;
    if (!count) return;
    const button = node('button','wh-category-button');
    button.type = 'button';
    button.dataset.category = category.id;
    button.setAttribute('aria-pressed',String(category.id === activeCategory));
    button.setAttribute('aria-controls','wh-products');
    button.append(node('span','',category.label),node('span','wh-category-count',String(count)));
    button.addEventListener('click', () => {
      activeCategory = category.id;
      visibleLimit = 24;
      categoryButtons.forEach((entry,id) => entry.setAttribute('aria-pressed',String(id === activeCategory)));
      filterCards();
    });
    categoryButtons.set(category.id,button);
    $('#wh-categories').append(button);
  });
  $('#wh-category-filter').hidden = false;

  function filterCards() {
    const terms = normalize($('#wh-search').value).split(/\s+/).filter(Boolean);
    const stockedOnly = $('#wh-stock').checked;
    const matches = cards.filter(card => (activeCategory === 'all' || cardCategories.get(card).includes(activeCategory)) && terms.every(term => normalize(card.dataset.search).includes(term)) && (!stockedOnly || card.dataset.available === 'true'));
    const visible = new Set(matches.slice(0, visibleLimit));
    cards.forEach(card => {
      card.hidden = !visible.has(card);
      if (!card.hidden) {
        const image = card.querySelector('.wh-product-image img');
        if (image) image.loading = 'eager';
      }
    });
    $('#wh-result-count').textContent = `${matches.length}商品中 ${Math.min(visibleLimit,matches.length)}商品を表示`;
    $('#wh-no-results').hidden = matches.length > 0;
    $('#wh-show-more').hidden = matches.length <= visibleLimit;
  }
  $('[data-search-controls]').hidden = false;
  $('#wh-search').addEventListener('input', () => { visibleLimit = 24; filterCards(); });
  $('#wh-stock').addEventListener('change', () => { visibleLimit = 24; filterCards(); });
  $('#wh-show-more').addEventListener('click', () => { visibleLimit += 24; filterCards(); });
  filterCards();

  function renderEstimate() {
    const groups = new Map();
    selected.forEach(item => {
      if (!groups.has(item.productId)) groups.set(item.productId, { title:item.title, quantity:0, lines:[] });
      const group = groups.get(item.productId);
      group.quantity += item.quantity;
      group.lines.push(item);
    });
    let subtotal = 0;
    let totalQuantity = 0;
    const fragment = document.createDocumentFragment();
    const text = ['いぬのくらし 卸価格の見積（税込）', '※この見積では注文は確定しません。', ''];
    groups.forEach(group => {
      const discount = rate(group.quantity);
      const block = node('div','wh-estimate-group');
      block.append(node('h4','',group.title));
      block.append(node('span','wh-group-rate',`同一商品 合計${group.quantity}個 / ${discount}%OFF`));
      text.push(`${group.title}（合計${group.quantity}個・${discount}%OFF）`);
      group.lines.forEach(item => {
        const total = lineTotal(item.price,item.quantity,discount);
        subtotal += total;
        totalQuantity += item.quantity;
        const row = node('div','wh-estimate-row');
        row.append(node('span','',`${item.variantTitle === 'Default Title' ? '通常' : item.variantTitle}${item.sku ? ` / ${item.sku}` : ''}`));
        const label = node('label','','数量');
        const input = node('input');
        Object.assign(input,{type:'number',min:'1',max:'9999',step:'1',value:String(item.quantity),inputMode:'numeric'});
        input.setAttribute('aria-label', `${item.title} ${item.variantTitle}の数量`);
        input.addEventListener('change', () => {
          const next = number(input.value);
          if (next === null) { input.value = String(item.quantity); feedback('数量は1〜9999の整数で入力してください。'); return; }
          item.quantity = next;
          renderEstimate();
        });
        label.append(input);
        row.append(label,node('strong','',money(total)));
        const remove = node('button','wh-remove','削除');
        remove.type = 'button';
        remove.setAttribute('aria-label',`${item.title} ${item.variantTitle}を見積から削除`);
        remove.addEventListener('click', () => { selected.delete(item.variantId); renderEstimate(); feedback('見積から削除しました。'); });
        row.append(remove);
        block.append(row);
        text.push(`  ${item.variantTitle === 'Default Title' ? '通常' : item.variantTitle} / ${item.quantity}個 / ${money(total)}`);
      });
      fragment.append(block);
      text.push('');
    });
    const shipping = totalQuantity ? subtotal >= 10000 ? 0 : 800 : 0;
    $('#wh-estimate-lines').replaceChildren(fragment);
    $('#wh-subtotal').textContent = money(subtotal);
    $('#wh-shipping').textContent = shipping ? money(shipping) : '無料';
    $('#wh-total').textContent = money(subtotal + shipping);
    $('#wh-estimate').hidden = selected.size === 0;
    $('#wh-selection-link').hidden = selected.size === 0;
    $('#wh-selection-count').textContent = String(totalQuantity);
    text.push(`割引後の商品合計：${money(subtotal)}`,`送料：${money(shipping)}`,`お支払い合計の目安：${money(subtotal + shipping)}`, '', 'お支払い：クレジットカード・銀行振込（前払い）', '1円未満の端数は見積用に四捨五入しています。実際の金額・在庫は注文確定前にご確認ください。');
    if (root.dataset.ordering !== 'true') text.push('現在、オンライン発注は準備中です。');
    copyText = text.join('\n');
    if (readTransfer()) {
      if (!selected.size) clearTransfer();
      else {
        try { sessionStorage.setItem(transferKey,JSON.stringify({updatedAt:Date.now(),text:copyText,items:[...selected.values()].map(item=>({variantId:item.variantId,quantity:item.quantity}))})); }
        catch (_) { clearTransfer(); }
      }
    }
  }

  $('#wh-attach-estimate')?.addEventListener('click', () => {
    if (!selected.size) return;
    try {
      sessionStorage.setItem(transferKey,JSON.stringify({updatedAt:Date.now(),text:copyText,items:[...selected.values()].map(item=>({variantId:item.variantId,quantity:item.quantity}))}));
      window.location.assign(root.dataset.applicationUrl + '#wh-apply');
    } catch (_) {
      $('#wh-cart-message').textContent = 'このブラウザでは見積を引き継げません。「見積内容をコピー」でコピーし、お取引申請ページのご相談欄に貼り付けてください。';
    }
  });

  cards.forEach(card => {
    const select = card.querySelector('.wh-variant');
    const add = card.querySelector('.wh-add');
    add.addEventListener('click', () => {
      const option = select.selectedOptions[0];
      const quantity = number(card.querySelector('.wh-quantity').value);
      if (!option || option.dataset.available !== 'true') { feedback('この種類は現在在庫切れです。'); return; }
      if (quantity === null) { feedback('数量は1〜9999の整数で入力してください。'); card.querySelector('.wh-quantity').focus(); return; }
      const existing = selected.get(option.value);
      if (existing && existing.quantity + quantity > 9999) { feedback('同じ種類の見積数量は9999個までです。'); return; }
      selected.set(option.value, {productId:card.dataset.productId,title:card.dataset.title,variantId:option.value,variantTitle:option.dataset.variantTitle,sku:option.dataset.sku,price:Number(option.dataset.price),quantity:(existing?.quantity || 0)+quantity});
      renderEstimate();
      feedback(`${quantity}個を見積に追加しました。画面右下の「選択内容を見る」から合計を確認できます。`);
      const original = add.textContent;
      add.textContent = '追加しました ✓';
      setTimeout(() => { add.textContent = original; }, 1500);
    });
  });


  const savedEstimate = readTransfer();
  if (savedEstimate) {
    let skipped = 0;
    for (const item of savedEstimate.items) {
      const quantity = number(item.quantity);
      let match;
      for (const card of cards) {
        const option = [...card.querySelector('.wh-variant').options].find(option=>option.value===String(item.variantId));
        if (option) { match = {card,option}; break; }
      }
      if (!match || !quantity || match.option.dataset.available !== 'true') { skipped++; continue; }
      const {card,option} = match;
      selected.set(option.value,{productId:card.dataset.productId,title:card.dataset.title,variantId:option.value,variantTitle:option.dataset.variantTitle,sku:option.dataset.sku,price:Number(option.dataset.price),quantity});
    }
    if (selected.size) renderEstimate();
    else clearTransfer();
    if (skipped) feedback('在庫切れ・販売終了などにより、一部の商品を見積から外しました。現在の商品と数量をご確認ください。');
  }

  $('#wh-copy-estimate').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      $('#wh-cart-message').textContent = '見積内容をコピーしました。';
    } catch (_) {
      let fallback = $('#wh-copy-fallback');
      if (!fallback) {
        const label = node('label','','見積内容（選択してコピーしてください）');
        fallback = node('textarea');
        fallback.id = 'wh-copy-fallback';
        fallback.rows = 8;
        fallback.readOnly = true;
        label.append(fallback);
        $('#wh-cart-message').after(label);
      }
      fallback.value = copyText;
      fallback.focus();
      fallback.select();
      $('#wh-cart-message').textContent = '見積内容を選択しました。コピーしてお使いください。';
    }
  });

  const addToCart = $('#wh-cart-add');
  if (addToCart && root.dataset.ordering === 'true' && root.dataset.approved === 'true') {
    addToCart.addEventListener('click', async () => {
      if (!selected.size) return;
      addToCart.disabled = true;
      $('#wh-cart-message').textContent = '在庫を確認してカートに追加しています。';
      try {
        const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[...selected.values()].map(item=>({id:item.variantId,quantity:item.quantity}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : '在庫・数量をご確認ください。');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        $('#wh-cart-message').textContent = `カートへの追加を完了できませんでした。${error.message} カートの内容を確認してからお試しください。`;
        addToCart.disabled = false;
      }
    });
  }
})();
